import { createFileRoute } from '@tanstack/react-router';
import { EditScreeningForm } from './components/EditScreeningForm.tsx';

export const Route = createFileRoute('/screening/$screeningId/')({
  component: Screening,
  staticData: { title: 'Personalien' },
});

function Screening() {
  const { screeningId } = Route.useParams();

  return <EditScreeningForm screeningId={screeningId} />;
}
